import React, { useEffect, useState } from "react";
import style from "css/workspace.module.css";
import Detailvideocommon from "./detailvideocommon";
import Questions from "components/app/questions";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import { openPopup } from "redux/slices/drawerPopupSlice";
import { useDispatch } from "react-redux";
import NeatPopup from "components/device/neat/neatPopup";

function Videoconference(props) {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const location = useLocation();
  const [status, setStatus] = useState(props.status);
  const individualCI = {
    info1: "개인사무실",
    info2: "1인",
    info3: "소규모의 영상회의 / 개인 작업에 최적화된 구성입니다.",
    info4: [
      { txt: "포커스 룸" },
      { txt: "1인용 사무실" },
      { txt: "개인 상담 공간" },
    ],
    img1: "img/smartspace/individualInfoImg1.png",
    img2: "img/smartspace/individualInfoImg2.png",
    img1_m: "img/smartspace/individualInfoImg1_m.png",
    img2_m: "img/smartspace/individualInfoImg2_m.png",
    info5: (
      <p>
        <font>다양한 공간과{"\n"}목적에 맞도록 설계</font>되었습니다.
      </p>
    ),
    info6: (
      <p>
        업무 형태·환경에 따른 <font>최적의 공간이 필요</font>합니다.
        <br /> 다양한 포지션의 직원들이 근무하고{"\n"} 협업하는데 최적의 공간을
        구축하세요.
        <br />
        <font> 이용목적과 형태에 맞는{"\n"} 화상회의실 구축</font>이 가능합니다.
      </p>
    ),
    img3: "img/smartspace/individualInfoImg3.png",
    img3_m: "img/smartspace/individualInfoImg3_m.png",
    imgLabel3: "경영진용 / 1-2인용 사무실",
    img4: "img/smartspace/individualInfoImg4.png",
    img4_m: "img/smartspace/individualInfoImg4_m.png",
    imgLabel4: "포커스룸",
  };
  const smallCI = {
    info1: "중소형 회의실",
    info2: "최대 10명",
    info3: "최대 10명을 위한 다양한 규모의 회의·공간에 적합합니다.",
    info4: [
      { txt: "소형 회의실" },
      { txt: "중형 회의실" },
      { txt: "다목적실" },
    ],
    img1: "img/smartspace/smallInfoImg1.png",
    img2: "img/smartspace/smallInfoImg2.png",
    img1_m: "img/smartspace/smallInfoImg1_m.png",
    img2_m: "img/smartspace/smallInfoImg2_m.png",
    info5: (
      <p>
        <font>다양한 공간과{"\n"}목적에 맞도록 설계</font>되었습니다.
      </p>
    ),
    info6: (
      <p>
        업무 형태·환경에 따른 <font>최적의 공간이 필요</font>합니다.
        <br /> 다양한 포지션의 직원들이 근무하고{"\n"} 협업하는데 최적의 공간을
        구축하세요.
        <br />
        <font> 이용목적과 형태에 맞는{"\n"} 화상회의실 구축</font>이 가능합니다.
      </p>
    ),
    img3: "img/smartspace/smallInfoImg3.png",
    img3_m: "img/smartspace/smallInfoImg3_m.png",
    imgLabel3: "아이데이션 회의실",
    img4: "img/smartspace/smallInfoImg4.png",
    img4_m: "img/smartspace/smallInfoImg4_m.png",
    imgLabel4: "중 / 소형 회의실",
  };
  const largeCI = {
    info1: "대형 회의실",
    info2: "10인 이상",
    info3:
      "10명 이상의 대형 회의·공간에 적합하며,\n 3개의 대형 화면을 구동할 수 있습니다.",
    info4: [{ txt: "대형 회의실" }, { txt: "수용인원 10명 이상의 회의실" }],
    img1: "img/smartspace/largeInfoImg1.png",
    img2: "img/smartspace/largeInfoImg2.png",
    img1_m: "img/smartspace/largeInfoImg1_m.png",
    img2_m: "img/smartspace/largeInfoImg2_m.png",
    info5: (
      <p>
        <font>다양한 공간과{"\n"}목적에 맞도록 설계</font>되었습니다.
      </p>
    ),
    info6: (
      <p>
        업무 형태·환경에 따른 <font>최적의 공간이 필요</font>합니다.
        <br /> 다양한 포지션의 직원들이 근무하고{"\n"} 협업하는데 최적의 공간을
        구축하세요.
        <br />
        <font> 이용목적과 형태에 맞는{"\n"} 화상회의실 구축</font>이 가능합니다.
      </p>
    ),
    img3: "img/smartspace/largeInfoImg3.png",
    img3_m: "img/smartspace/largeInfoImg3_m.png",
    imgLabel3: "대형 회의실",
    img4: "img/smartspace/largeInfoImg4.png",
    img4_m: "img/smartspace/largeInfoImg4_m.png",
    imgLabel4: "대형 세미나실",
  };
  const loungeCI = {
    info1: "공용라운지 및 오피스",
    info2: "최대 10명",
    info3:
      "최대 10명까지 수용할 수 있는\n 개방된 공간, 모임 및 회의실에 적합합니다. \n 유휴 시설인 휴게공간을 활용하여\n 부족한 회의실 자원을 확중할 수 있습니다.",
    info4: [
      { txt: "공용 라운지" },
      { txt: "아이데이션 회의실" },
      { txt: "휴게공간" },
    ],
    img1: "img/smartspace/loungeInfoImg1.png",
    img2: "img/smartspace/loungeInfoImg2.png",
    img1_m: "img/smartspace/loungeInfoImg1_m.png",
    img2_m: "img/smartspace/loungeInfoImg2_m.png",
    info5: (
      <p>
        <font>다양한 공간과{"\n"}목적에 맞도록 설계</font>되었습니다.
      </p>
    ),
    info6: (
      <p>
        업무 형태·환경에 따른 <font>최적의 공간이 필요</font>합니다.
        <br /> 다양한 포지션의 직원들이 근무하고{"\n"} 협업하는데 최적의 공간을
        구축하세요.
        <br />
        <font> 이용목적과 형태에 맞는{"\n"} 화상회의실 구축</font>이 가능합니다.
      </p>
    ),
    img3: "img/smartspace/loungeInfoImg3.png",
    img3_m: "img/smartspace/loungeInfoImg3_m.png",
    imgLabel3: "공용 공간 및 아이데이션 회의실",
    img4: "img/smartspace/loungeInfoImg4.png",
    img4_m: "img/smartspace/loungeInfoImg4_m.png",
    imgLabel4: "휴게 공간",
  };

  const [commonInfo, setCommonInfo] = useState(individualCI);
  ////////////////////////////////////
  const individualBH = (
    <div
      className={style.bodyTitle}
      style={isMobile || isTablet ? { fontSize: "20px" } : {}}
    >
      <p>
        <font>개인 사무실 (1인)</font>에 최적화된 화상회의 시스템
      </p>
    </div>
  );
  const smallBH = (
    <div
      className={style.bodyTitle}
      style={isMobile || isTablet ? { fontSize: "20px" } : {}}
    >
      <p>
        <font>중소형 회의실 (최대10인)</font>에 최적화된{"\n"}화상회의 시스템
      </p>
    </div>
  );
  const largeBH = (
    <div
      className={style.bodyTitle}
      style={isMobile || isTablet ? { fontSize: "20px" } : {}}
    >
      <p>
        <font>대형 회의실 (10인 이상)</font>에 최적화된{"\n"}화상회의 시스템
      </p>
    </div>
  );
  const loungeBH = (
    <div
      className={style.bodyTitle}
      style={isMobile || isTablet ? { fontSize: "20px" } : {}}
    >
      <p>
        <font>공용라운지 및 아이디어 (최대 10명)</font>에{"\n"} 최적화된
        화상회의 시스템
      </p>
    </div>
  );
  const [BodyHeader, setBodyHeader] = useState(individualBH);

  ///////////////////////////////

  const individualBI = [
    {
      id: 1,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                리브테크놀로지의 all Place 플랫폼을 사용하면 개인 회의실의
                예약과 관리가 매우
              </font>
              <font>
                간편해집니다. 직관적인 인터페이스로 손쉽게 회의실을 예약하고
                관리할 수 있습니다.
              </font>
            </>
          ) : (
            <>
              <font>
                리브테크놀로지의 all Place 플랫폼을 사용하면 개인 회의실의
                예약과 관리가 매우 간편해집니다. {"\n"}직관적인 인터페이스로
                손쉽게 회의실을 예약하고 관리할 수 있습니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "회의실 예약 플랫폼\n ( Meeting room Reservation )",
      img: "img/smartspace/individualBody1.png",
      img_m: "img/smartspace/individualBody1_m.png",
    },
    {
      id: 2,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                Neat Frame은 선명한 영상과 음질을 제공하며, 개인 사무실에서도
                최적의
              </font>
              <font>
                화상회의 환경을 구축합니다. 컴팩트한 디자인으로 작은 공간에도
                쉽게 설치
              </font>
              <font>
                가능하며, 사용자가 화상회의 중에도 몰입감을 유지할 수 있도록
                도와줍니다.
              </font>
            </>
          ) : (
            <>
              <font>
                Neat Frame은 선명한 영상과 음질을 제공하며, 개인 사무실에서도
                최적의 화상회의 환경을 구축합니다.{"\n"}컴팩트한 디자인으로 작은
                공간에도 쉽게 설치 가능하며, 사용자가 화상회의 중에도 몰입감을
                유지할 수 있도록 도와줍니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "고품질 화상회의 환경 제공\n ( Neat Device )",
      img: "img/smartspace/individualBody2.png",
      img_m: "img/smartspace/individualBody2_m.png",
    },
    {
      id: 3,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                Neat Pad는 회의 일정 확인 및 간편한 제어를 위한 직관적인
                터치스크린 디바이스입니다.
              </font>
              <font>
                회의실 예약, 시작 및 종료 등 모든 기능을 손쉽게 조작할 수 있어,
              </font>
              <font> 사용자는 더 편리하게 회의를 운영할 수 있습니다.</font>
            </>
          ) : (
            <>
              <font>
                Neat Pad는 회의 일정 확인 및 간편한 제어를 위한 직관적인
                터치스크린 디바이스입니다.{"\n"} 회의실 예약, 시작 및 종료 등
                모든 기능을 손쉽게 조작할 수 있어,사용자는 더 편리하게 회의를
                운영할 수 있습니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "직관적인 터치 컨트롤과 편의성\n ( Touch Control )",
      img: "img/smartspace/individualBody3.png",
      img_m: "img/smartspace/individualBody3_m.png",
    },
    {
      id: 4,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                각 기업의 요구사항에 맞춘 맞춤형 화상회의 시스템을 제공합니다.
              </font>
              <font>
                기업의 규모와 업무환경에 최적화된 솔루션을 설계하여 최고의
                성과를
              </font>
              <font> 낼 수 있도록 지원합니다.</font>
            </>
          ) : (
            <>
              <font>
                각 기업의 요구사항에 맞춘 맞춤형 화상회의 시스템을 제공합니다.
                {"\n"}기업의 규모와 업무환경에 최적화된 솔루션을 설계하여 최고의
                성과를 낼 수 있도록 지원합니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "기업 환경 맞춤형 시스템 구축\n (Custom System)",
      img: "img/smartspace/individualBody4.png",
      img_m: "img/smartspace/individualBody4_m.png",
    },
  ];
  const smallBI = [
    {
      id: 1,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                리브테크놀로지의 all Place 플랫폼을 사용하면 중소형 회의실의
                예약과 관리가 매우
              </font>
              <font>
                간편해집니다. 직관적인 인터페이스로 손쉽게 회의실을 예약하고
                관리할 수 있습니다.
              </font>
            </>
          ) : (
            <>
              <font>
                리브테크놀로지의 all Place 플랫폼을 사용하면 중소형 회의실의
                예약과 관리가 매우 간편해집니다. {"\n"}직관적인 인터페이스로
                손쉽게 회의실을 예약하고 관리할 수 있습니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "회의실 예약 플랫폼\n ( Meeting room Reservation )",
      img: "img/smartspace/smallBody1.png",
      img_m: "img/smartspace/smallBody1_m.png",
    },
    {
      id: 2,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                최신 AI 기술이 적용된 Neat장비는 고품질의 영상과 음성으로 회의의
                몰입도를
              </font>
              <font>
                극대화합니다. 자동 프레이밍, 노이즈 캔슬링 등으로 최대 10명이
                참여하는
              </font>
              <font>
                회의에서도 모든 참석자가 최적의 환경에서 소통할 수 있습니다.
              </font>
            </>
          ) : (
            <>
              <font>
                최신 AI 기술이 적용된 Neat장비는 고품질의 영상과 음성으로 회의의
                몰입도를 극대화합니다. 자동 프레이밍, 노이즈 캔슬링 등으로 최대
                10명이 참여하는 회의에서도 모든 참석자가 최적의 환경에서 소통할
                수 있습니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "몰입도를 높여주는 Neat 장비\n ( Neat Device )",
      img: "img/smartspace/smallBody2.png",
      img_m: "img/smartspace/smallBody2_m.png",
    },
    {
      id: 3,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                ClickShare를 통해 중소형 회의실에서 복잡한 케이블 연결 없이
              </font>
              <font>무선으로 간편하게 프레젠테이션을 진행하세요.</font>
              <font>
                버튼 하나로 손쉽게 화면을 공유하여 회의를 더욱 효율적이고
                원활하게 진행할 수 있습니다.
              </font>
            </>
          ) : (
            <>
              <font>
                ClickShare를 통해 중소형 회의실에서 복잡한 케이블 연결 없이
                무선으로 간편하게 프레젠테이션을 진행하세요.{"\n"}
                버튼 하나로 손쉽게 화면을 공유하여 회의를 더욱 효율적이고
                원활하게 진행할 수 있습니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "간편한 무선 프레젠테이션 ClickShare (Wireless)",
      img: "img/smartspace/smallBody3.png",
      img_m: "img/smartspace/smallBody3_m.png",
    },
    {
      id: 4,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              {" "}
              <font>
                각 기업의 요구사항에 맞춘 맞춤형 화상회의 시스템을 제공합니다.
              </font>
              <font>
                기업의 규모와 업무환경에 최적화된 솔루션을 설계하여 최고의
                성과를
              </font>
              <font> 낼 수 있도록 지원합니다.</font>
            </>
          ) : (
            <>
              <font>
                각 기업의 요구사항에 맞춘 맞춤형 화상회의 시스템을 제공합니다.
                {"\n"}
                기업의 규모와 업무환경에 최적화된 솔루션을 설계하여 최고의
                성과를 낼 수 있도록 지원합니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "기업 환경 맞춤형 시스템 구축\n (Custom System)",
      img: "img/smartspace/smallBody4.png",
      img_m: "img/smartspace/smallBody4_m.png",
    },
  ];
  const largeBI = [
    {
      id: 1,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                리브테크놀로지의 all Place 플랫폼은 대형 회의실의 예약과 관리를
                스마트하게
              </font>
              <font>
                해줍니다. 사용자 친화적인 인터페이스를 통해 신속하고 손쉽게
                회의실을 예약하고
              </font>
              <font>관리할 수 있습니다.</font>
            </>
          ) : (
            <>
              <font>
                리브테크놀로지의 all Place 플랫폼은 대형 회의실의 예약과 관리를
                스마트하게 해줍니다. 사용자 친화적인 인터페이스를 통해 신속하고
                손쉽게 회의실을 예약하고 관리할 수 있습니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "회의실 예약 플랫폼\n ( Meeting room Reservation )",
      img: "img/smartspace/largeBody1.png",
      img_m: "img/smartspace/largeBody1_m.png",
    },
    {
      id: 2,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                대형 회의실에서도 Neat 장비는 탁월한 성능을 발휘합니다. 자동
                프레이밍과
              </font>
              <font>
                소음 제거 기능으로, 다수의 참석자가 참여하는 회의에서도 모든
                참가자가
              </font>
              <font>몰입할 수 있는 최적의 환경을 조성합니다.</font>
            </>
          ) : (
            <>
              <font>
                대형 회의실에서도 Neat 장비는 탁월한 성능을 발휘합니다. 자동
                프레이밍과 소음 제거 기능으로, 다수의 참석자가 참여하는
                회의에서도 모든 참가자가 몰입할 수 있는 최적의 환경을
                조성합니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "몰입도를 높여주는 Neat 장비\n ( Neat Device )",
      img: "img/smartspace/largeBody2.png",
      img_m: "img/smartspace/largeBody2_m.png",
    },
    {
      id: 3,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                대형 회의실에서도 ClickShare를 통해 복잡한 케이블 연결 없이
                무선으로 손쉽게
              </font>
              <font>
                프레젠테이션을 진행하세요. 버튼 하나로 간편하게 화면을 공유하여
                회의의 효율성과
              </font>
              <font>원활함을 극대화할 수 있습니다.</font>
            </>
          ) : (
            <>
              <font>
                대형 회의실에서도 ClickShare를 통해 복잡한 케이블 연결 없이
                무선으로 손쉽게 프레젠테이션을 진행하세요. 버튼 하나로 간편하게
                화면을 공유하여 회의의 효율성과 원활함을 극대화할 수 있습니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "간편한 무선 프레젠테이션 ClickShare (Wireless)",
      img: "img/smartspace/largeBody3.png",
      img_m: "img/smartspace/largeBody3_m.png",
    },
    {
      id: 4,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                각 기업의 요구사항에 맞춘 맞춤형 화상회의 시스템을 제공합니다.
              </font>
              <font>
                기업의 규모와 업무환경에 최적화된 솔루션을 설계하여 최고의
                성과를
              </font>
              <font> 낼 수 있도록 지원합니다.</font>
            </>
          ) : (
            <>
              <font>
                각 기업의 요구사항에 맞춘 맞춤형 화상회의 시스템을 제공합니다.
                {"\n"}
                기업의 규모와 업무환경에 최적화된 솔루션을 설계하여 최고의
                성과를 낼 수 있도록 지원합니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "기업 환경 맞춤형 시스템 구축\n (Custom System)",
      img: "img/smartspace/largeBody4.png",
      img_m: "img/smartspace/largeBody4_m.png",
    },
  ];
  const loungeBI = [
    {
      id: 1,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                리브테크놀로지의 all Place 플랫폼은 공용라운지 및 아이디어
                공간의 예약과 관리를
              </font>
              <font>
                스마트하게 해줍니다. 사용자 친화적인 인터페이스를 통해 신속하고
                손쉽게 회의실을
              </font>
              <font>예약하고 관리할 수 있늡니다.</font>
            </>
          ) : (
            <>
              <font>
                리브테크놀로지의 all Place 플랫폼은 공용라운지 및 아이디어
                공간의 예약과 관리를 스마트하게 해줍니다.{"\n"} 사용자 친화적인
                인터페이스를 통해 신속하고 손쉽게 회의실을 예약하고 관리할 수
                있늡니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "회의실 예약 플랫폼\n ( Meeting room Reservation )",
      img: "img/smartspace/loungeBody1.png",
      img_m: "img/smartspace/loungeBody1_m.png",
    },
    {
      id: 2,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                Neat 장비는 공용라운지 및 아이디어 공간에서도 뛰어난 성능을
                발휘합니다.
              </font>
              <font>
                자동 트레이닝과 소음 제거 기능을 통해 최대10인이 참여하는
                회의에서도
              </font>
              <font>
                모든 참가자가 몰입할 수 있는 최적의 환경을 조성합니다.
              </font>
            </>
          ) : (
            <>
              <font>
                Neat 장비는 공용라운지 및 아이디어 공간에서도 뛰어난 성능을
                발휘합니다.{"\n"}자동 트레이닝과 소음 제거 기능을 통해
                최대10인이 참여하는 회의에서도 모든 참가자가 몰입할 수 있는
                최적의 환경을 조성합니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "몰입도를 높여주는 Neat 장비\n ( Neat Device )",
      img: "img/smartspace/loungeBody2.png",
      img_m: "img/smartspace/loungeBody2_m.png",
    },
    {
      id: 3,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                공용라운지에서도 ClickShare를 통해 복잡한 케이블 연결 없이
                무선으로 손쉽게
              </font>
              <font>
                프레젠테이션을 진행하세요. 버튼 하나로 간편하게 화면을 공유하여
                회의의 효율성과
              </font>
              <font>원활함을 극대화할 수 있습니다.</font>
            </>
          ) : (
            <>
              <font>
                공용라운지에서도 ClickShare를 통해 복잡한 케이블 연결 없이
                무선으로 손쉽게 프레젠테이션을 진행하세요.{"\n"} 버튼 하나로
                간편하게 화면을 공유하여 회의의 효율성과 원활함을 극대화할 수
                있습니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "간편한 무선 프레젠테이션 ClickShare (Wireless)",
      img: "img/smartspace/loungeBody3.png",
      img_m: "img/smartspace/loungeBody3_m.png",
    },
    {
      id: 4,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                각 기업의 요구사항에 맞춘 맞춤형 화상회의 시스템을 제공합니다.
              </font>
              <font>
                기업의 규모와 업무환경에 최적화된 솔루션을 설계하여 최고의
                성과를
              </font>
              <font> 낼 수 있도록 지원합니다.</font>
            </>
          ) : (
            <>
              <font>
                각 기업의 요구사항에 맞춘 맞춤형 화상회의 시스템을 제공합니다.
                기업의 규모와 업무환경에 최적화된 솔루션을 설계하여 최고의
                성과를 낼 수 있도록 지원합니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "기업 환경 맞춤형 시스템 구축\n (Custom System)",
      img: "img/smartspace/loungeBody4.png",
      img_m: "img/smartspace/loungeBody4_m.png",
    },
  ];
  const [BodyInfo, setBodyInfo] = useState(individualBI);

  const individualCompose = [
    {
      id: 1,
      img: "img/smartspace/composeImg1.png",
      title: "스마트 워크 플랫폼 all Place",
      txt: "all Place는 회의실/자율좌석 예약 및 관리 플랫폼입니다.\n 사용자가 PC나 모바일을 통해 쉽게 예약할 수 있게 해주며, \n예얀된 내용을 회의실 디스플레이 장비와 실시간으로 동기화됩니다.",
      onClick: () => showDrawer("allplace"),
    },
    {
      id: 2,
      img: "img/device/neat/swiper_frame.png",
      title: "화상회의 장비 neat.frame",
      txt: "Neat Frame은 간결하면서도 강력한 화상 디바이스로, 개인사무실에 최적화된 장비입니다. 고해상도 디스플레이와 초고화질 카메라를 탑재하여 선명하고 깨끗한 화면으로 소통할 수 있습니다.",
      onClick: () => showDrawer("frame"),
    },
    {
      id: 3,
      img: "img/device/neat/swiper_pad.png",
      title: "회의실 현황 및 컨트롤러 neat.pad",
      txt: "회의실 앞에 설치된 Wall Pad는 회의실 예약 및 상태를 실시간으로 확인할 수 있는 디바이스입니다. 사용자는 Wall Pad를 통해 회의실의 예약 현황을 확인하고, 간편하게 회의실 예약, 시작 및 종료를 관리할 수 있어 효율적인 공간 활용이 가능합니다.",
      onClick: () => showDrawer("pad"),
    },
  ];
  const smallCompose = [
    {
      id: 1,
      img: "img/smartspace/composeImg1.png",
      title: "스마트 워크 플랫폼 all Place",
      txt: "all Place는 회의실/자율좌석 예약 및 관리 플랫폼입니다.\n 사용자가 PC나 모바일을 통해 쉽게 예약할 수 있게 해주며, \n예얀된 내용을 회의실 디스플레이 장비와 실시간으로 동기화됩니다.",
      onClick: () => showDrawer("allplace"),
    },
    {
      id: 2,
      img: "img/device/neat/swiper_bar_2.png",
      title: "화상회의 장비 neat. bar generation2",
      txt: "Neat Bar Generation 2는 중대형 회의실에 최적화된 고성능 화상회의 솔루션입니다. 개선된 카메라와 오디오 기능으로 더 선명한 영상과 몰입감 있는 회의를 지원합니다.",
      onClick: () => showDrawer("bar2"),
    },
    // {
    //   id: 3,
    //   img: "img/device/neat/swiper_bar_pro.png",
    //   title: "화상회의 장비 neat. bar",
    //   txt: "Neat Bar는 간편한 설치와 사용이 특징인 소형 및 중형 회의실용 올인원 화상회의 디바이스입니다. Zoom, MS Teams와 같은 화상회의 플랫폼과 완벽하게 호환되며, 선명한 영상과 오디오 품질을 제공합니다.",
    //   onClick: () => showDrawer("bar"),
    // },
    {
      id: 3,
      img: "img/device/neat/swiper_pad.png",
      title: "회의실 현황 및 컨트롤러 neat.pad",
      txt: "Neat Pad는 회의실 벽에 부착할 수 있는 Wall Pad로 사용되며, 회의실 예약 현황을 실시간으로 보여줍니다. 또한, 회의 컨트롤러로써 회의 시작, 종료, 음소거 등 다양한 기능을 직관적으로 제어할 수 있어 회의 관리가 더욱 효율적입니다.",
      onClick: () => showDrawer("pad"),
    },
    // {
    //   id: 5,
    //   img: "img/smartspace/composeImg1.png",
    //   title: "neat. frame",
    //   txt: "Neat Frame은 간결하면서도 강력한 화상 디바이스로, 가상 \n 리셉셔니스트 역할에 최적화된 장비입니다. 고해상도 디스플레이와 \n 초고화질 카메라를 탑재하여, 방문자와 직원 모두에게 선명하고\n 깨끗한 화면으로 소통할 수 있습니다.",
    //   link: "smart-space/work/platform",
    // },
  ];
  const largeCompose = [
    {
      id: 1,
      img: "img/smartspace/composeImg1.png",
      title: "스마트 워크 플랫폼 all Place",
      txt: "all Place는 회의실/자율좌석 예약 및 관리 플랫폼입니다.\n 사용자가 PC나 모바일을 통해 쉽게 예약할 수 있게 해주며, \n예얀된 내용을 회의실 디스플레이 장비와 실시간으로 동기화됩니다.",
      onClick: () => showDrawer("allplace"),
    },
    {
      id: 2,
      img: "img/device/neat/swiper_bar_pro.png",
      title: "화상회의 장비 neat. bar pro",
      txt: "Neat Bar Pro는 대형 회의실 및 임원 회의실에 최적화된 프리미엄\n화상회의 솔루션입니다. 확장된 카메라 및 오디오 시스템으로 다수의\n참가자도 선명하게 포착하며, 몰입감 있는 회의를 제공합니다.",
      onClick: () => showDrawer("bar"),
    },
    {
      id: 3,
      img: "img/device/neat/swiper_pad.png",
      title: "회의실 현황 및 컨트롤러 neat.pad",
      txt: "Neat Pad는 회의실 벽에 부착할 수 있는 Wall Pad로 사용되며, 회의실 예약 현황을 실시간으로 보여줍니다. 또한, 회의 컨트롤러로써 회의 시작, 종료, 음소거 등 다양한 기능을 직관적으로 제어할 수 있어 회의 관리가 더욱 효율적입니다.",
      onClick: () => showDrawer("pad"),
    },
    {
      id: 4,
      img: "img/device/neat/swiper_clickshare.png",
      title: "무선 프레젠테이션  ClickShare",
      txt: "ClickShare는 회의실에서 별도의 케이블 없이 무선으로 화면을 공유할 수 있는 솔루션입니다. 버튼 클릭 한 번으로 회의실 디스플레이에 콘텐츠를 손쉽게 전송하고, 빠르고 원활한 협업 환경을 제공합니다.",
      onClick: () => showDrawer("clickshare"),
    },
  ];
  const loungeCompose = [
    {
      id: 1,
      img: "img/smartspace/composeImg1.png",
      title: "스마트 워크 플랫폼 all Place",
      txt: "all Place는 회의실/자율좌석 예약 및 관리 플랫폼입니다.\n 사용자가 PC나 모바일을 통해 쉽게 예약할 수 있게 해주며, \n예얀된 내용을 회의실 디스플레이 장비와 실시간으로 동기화됩니다.",
      onClick: () => showDrawer("allplace"),
    },
    {
      id: 2,
      img: "img/device/neat/swiper_board_pro.png",
      title: "화상회의 장비 neat. board Pro",
      txt: "Neat Board Pro는 중소형 회의실과 공용 라운지에 최적화된 올인원\n화상회의 및 협업 솔루션입니다. 대형 터치스크린과 내장 카메라로\n원활한 프레젠테이션과 화상회의를 지원하며, 실시간 화이트 보드\n기능으로 팀원 간의 아이디어 공유와 협업을 극대화합니다.",
      onClick: () => showDrawer("boardpro"),
    },
    {
      id: 3,
      img: "img/device/neat/swiper_board_50.png",
      title: "화상회의 장비 neat. board50",
      txt: "Neat Board 50은 협업 공간에 적합한 고성능 협업 솔루션입니다. 터치스크린과 화상회의 기능을 결합해, 직관적인 사용 경험과 원활한 아이디어 교류를 제공합니다. 다양한 회의 플랫폼과 호환되어 유연한 협업 환경을 지원합니다.",
      onClick: () => showDrawer("board50"),
    },
    {
      id: 4,
      img: "img/device/neat/swiper_pad.png",
      title: "회의실 현황 및 컨트롤러 neat. pad",
      txt: "Neat Pad는 회의실 벽에 부착할 수 있는 Wall Pad로 사용되며,\n회의실 예약 현황을 실시간으로 보여줍니다. 또한, 회의 컨트롤러로써\n회의 시작, 종료, 음소거 등 다양한 기능을 직관적으로 제어할 수 있어\n회의 관리가 더욱 효율적입니다.",
      onClick: () => showDrawer("pad"),
    },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      })
    );
    document.querySelector("#page_header").style.height = "0";
  };

  const [Compose, setCompose] = useState(individualCompose);

  useEffect(() => {
    if (location.state?.status && location.state?.status !== status) {
      setStatus(location.state?.status);
    }
  }, [location.state]);

  useEffect(() => {
    if (status === "small") {
      setCommonInfo(smallCI);
      setBodyHeader(smallBH);
      setBodyInfo(smallBI);
      setCompose(smallCompose);
    } else if (status === "large") {
      setCommonInfo(largeCI);
      setBodyHeader(largeBH);
      setBodyInfo(largeBI);
      setCompose(largeCompose);
    } else if (status === "lounge") {
      setCommonInfo(loungeCI);
      setBodyHeader(loungeBH);
      setBodyInfo(loungeBI);
      setCompose(loungeCompose);
    } else {
      setCommonInfo(individualCI);
      setBodyHeader(individualBH);
      setBodyInfo(individualBI);
      setCompose(individualCompose);
    }
  }, [status]);

  return (
    <>
      <SEOMeta
        title="화상회의 시스템, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - 화상회의 시스템"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, 화상회의 시스템, 개인 사무실, 중소형 회의실, 대형 회의실, 공용라운지 및 아이디어"
      />
      <NeatPopup />
      <div className={style.wrapper}>
        <div
          className={style.commonHeader}
          style={isMobile || isTablet ? { paddingBottom: 0 } : {}}
        >
          <div className={style.CommonHeaderTxt}>
            <p>Video Conference System</p>
            <p>화상회의 시스템</p>
            <p>
              <font>
                효율적인 예약 관리 플랫폼과{"\n"}첨단 화상회의 장비를 중심으로
                한
              </font>
              <font>통합솔루션을 제공하여</font>
              <font>대면 및 원격 협업을 원활하게 지원합니다.</font>
            </p>
          </div>
          {/* <img
          alt=""
          src={
            `${process.env.REACT_APP_CLIENT_URL}` +
            "img/smartspace/vcHeader.png"
          }
        /> */}
        </div>
        <div className={style.btnWrap}>
          <div
            className={status === "individual" ? style.vcOn : style.vcOff}
            onClick={() => setStatus("individual")}
          >
            {"개인 사무실\n(1인)"}
          </div>

          <div
            className={status === "small" ? style.vcOn : style.vcOff}
            onClick={() => setStatus("small")}
          >
            {"중소형 회의실\n(최대 10명)"}
          </div>
          <div
            className={status === "large" ? style.vcOn : style.vcOff}
            onClick={() => setStatus("large")}
          >
            {"대형 회의실\n(10인 이상)"}
          </div>
          <div
            className={status === "lounge" ? style.vcOn : style.vcOff}
            onClick={() => setStatus("lounge")}
          >
            {"공용라운지 및 아이디어\n(최대 10명 )"}
          </div>
        </div>
        <Detailvideocommon
          bodyHeader={BodyHeader}
          bodyInfo={BodyInfo}
          compose={Compose}
          commonInfo={commonInfo}
          status={status}
        />
        <Questions />
      </div>
    </>
  );
}

export default Videoconference;
